
import { defineComponent } from 'vue';

type Props = {
  error?: any;
  line?: {
    link: string;
    displayName: string;
    pictureUrl?: string;
  };
  errorCode?: number;
};

export default defineComponent({
  props: {
    error: {
      type: Object,
      default: () => null,
    },
    line: {
      type: Object,
      default: () => null,
    },
    errorCode: {
      type: Number,
      default: null,
    },
  },
  setup() {
    return {};
  },
});
